import { render } from "./PersonalDataProcessingPolicyScreen.vue?vue&type=template&id=42e742c6&scoped=true"
const script = {}

import "./PersonalDataProcessingPolicyScreen.vue?vue&type=style&index=0&id=42e742c6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42e742c6"]])

export default __exports__